export default __webpack_public_path__ + "assets/front/scss/editorial.af5728d855e3bd53fe85ea37af9c8086.css";